module.exports = __webpack_public_path__ + "media/images/logos/MARA-University-of-Technology-7e4d15b7d7164a6f43ef88ba5e9bb80d.svg";